// @flow


import { translate } from '../../../../../react/features/base/i18n/functions';
import React from 'react';
import { connect } from 'react-redux';

/**
 * The type of the React {@code Component} props of {@link NotificationTemplate}.
 */
type Props = {

    /**
     * The string in notify on first line description.
     */
    firstLine: string,

    /**
     * The string in notify on second line description.
     */
    secondLine: string,

    /**
     * The icon class name.
     */
    iconClass: string,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,
    _firstLineColor: string,
    _secondLineColor: string
};


/**
 * A component that renders the description of the notification for the recording initiator.
 *
 * @param {Props} props - The props of the component.
 * @returns {Component}
 */
function NotificationTemplate(props: Props) {
    const { firstLine, _firstLineColor, secondLine, _secondLineColor, iconClass, t } = props;

    return (
        <div>
            {firstLine && <div className={ `second-text ${_firstLineColor}`}>{t(firstLine.text)}</div>}
            {secondLine && <div className={`f-size_14 ${_secondLineColor}`}>{t(secondLine.text)}</div> }
            {iconClass && <i className={iconClass}></i> }
        </div>
    );
}


/**
 * Maps part of the Redix state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {Props}
 */
export function _mapStateToProps(state: Object, ownProps: Props) {
    const { firstLine, secondLine } = ownProps;

    return {
        _firstLineColor: (firstLine && firstLine.color) || 'color-yellow',
        _secondLineColor: (secondLine && secondLine.color) || 'color-red'
    };
}

export default translate(connect(_mapStateToProps)(NotificationTemplate));

